import { render, staticRenderFns } from "./GenreList.vue?vue&type=template&id=a102e8b4&"
import script from "./GenreList.vue?vue&type=script&lang=js&"
export * from "./GenreList.vue?vue&type=script&lang=js&"
import style0 from "./GenreList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports